import { render, staticRenderFns } from "./i-tab-item.vue?vue&type=template&id=f6ffffa0&"
import script from "./i-tab-item.vue?vue&type=script&lang=js&"
export * from "./i-tab-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports